import React, { useState } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import Button from '@mlb/react-patterns/components/Button/button.tsx';
import { media } from '@mlb/react-patterns/style/helpers/media.ts';
import COLORS from '@mlb/react-patterns/style/universal.color';

import { Tracking } from 'bdvp-tracking';

import Wrapper from '../ModalViewWrapper';
import Body from '../ModalBody';
import FooterComponent from '../ModalFooter';
import ThumbnailField from './ThumbnailField';
import TitleField from './TitleField';

const CreateReel = styled(Button)`
    width: 180px;
`;

const Footer = styled(FooterComponent)`
    justify-content: center;
`;

const LegalMessage = styled.p`
    color: ${COLORS.mlbGrey3};
    font-size: 11px;
    margin: 18px 0 0;
    line-height: normal;
    letter-spacing: 0.14px;
    ${media.mdmin`
        margin: 20px 0 0;
        font-size: 14px;
        letter-spacing: 0.18px;
    `}
`;

const CreationForm = (props) => {

    const {
        dictionary,
        reel,
        lastModalNode,
        validateReel,
        createReel,
        formState,
        setFormState,
    } = props;

    const [
        isValidating,
        setIsValidating,
    ] = useState(false);

    const handleChange = (event) => {

        const { name, value } = event.target;
        setFormState({
            ...formState,
            [name]: value,
            error: name === 'reelTitle' ? '' : formState.error,
        });

    };

    const handleSubmit = async(event) => {

        event.preventDefault();

        setIsValidating(true);

        const reelRequest = {
            reelTitle: formState.reelTitle,
            thumbnailUrl: formState.thumbnailUrl,
            reelClips: reel.reelClips.map(({
                __typename,
                mediaId,
                title,
                ...goodProps
            }) => ({
                ...goodProps,
            })),
        };

        const {
            valid,
            errors,
        } = await validateReel(reelRequest);

        if(valid) {

            return createReel(reelRequest);

        }

        setIsValidating(false);

        return setFormState({
            ...formState,
            error: errors[0],
        });

    };

    const isDisabled = formState.reelTitle.length < 1 || isValidating;
    const defaultLegalMessage = 'Find and share your finished reels on Your Reels page personalized with your MLB.com profile nickname.'
        + ' You can manage your nickname by visiting the Account section of MLB.com.';

    return (
        <Wrapper as={'form'} onSubmit={handleSubmit}>
            <Body>
                <ThumbnailField
                    dictionary={dictionary}
                    reel={reel}
                    formState={formState}
                    handleChange={handleChange}
                />
                <TitleField
                    dictionary={dictionary}
                    formState={formState}
                    handleChange={handleChange}
                    isLastNode={isDisabled}
                    lastModalNode={lastModalNode}
                />
            </Body>
            <Footer>
                <CreateReel
                    {...!isDisabled && { ref: lastModalNode }}
                    type={'submit'}
                    disabled={isDisabled}
                    size={'md'}
                    label={'Create Reel'}
                    styleName={'link-blue'}
                    handlers={{
                        onClick: () => {

                            Tracking.trackReelCreationFormSubmit();

                        },
                    }}
                />
                <LegalMessage>
                    {dictionary?.legal_message || defaultLegalMessage}
                </LegalMessage>
            </Footer>
        </Wrapper>
    );

};

CreationForm.propTypes = {
    dictionary: PropTypes.object.isRequired,
    reel: PropTypes.object.isRequired,
    lastModalNode: PropTypes.object.isRequired,
    validateReel: PropTypes.func.isRequired,
    createReel: PropTypes.func.isRequired,
    formState: PropTypes.object.isRequired,
    setFormState: PropTypes.func.isRequired,
};

export default CreationForm;
